import React from 'react';
import '../App.css';
import CSS from 'csstype';
import { useAppSelector, useAppDispatch } from '../app/hooks';

// images

// classes

// import state definition and functions (redux).
import {
  FileBrowserState,
  setParametersMaximised,
  setDetailsMaximised,
} from '../components/data-management/file-browser-slice';

//	--------------------------------------------------------------------------
//
//	P R O P E R T I E S
//
//	--------------------------------------------------------------------------

export enum SidePanelPosition {
  LEFT,
  RIGHT,
  BOTTOM,
}

//	--------------------------------------------------------------------------
//
//	H T M L   C U S T O M   C O M P O N E N T S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	C L A S S   D E F I N I T I O N
//
//	--------------------------------------------------------------------------

//	-------------------------------------------------
//
//	A side-panel container.
//
//	Parameters:
//
//		?: ?
//
//	-------------------------------------------------

export default function SidePanel(props: {
  children?: any;
  position: SidePanelPosition;
  title: string;
  maximised: boolean;
  minimised?: boolean;
  redux?: boolean;
  index?: number;
  setMaximised: any;
  size?: string;
  padding?: string;
  width?: string;
  height?: string;
  flex?: string;
  margin?: string;
  hideMinimisedPanel?: boolean;
  hideTitle?: boolean;
}) {
  //
  //	--------------------------------------------------------------------------
  //
  //	R E D U X   S T A T E   H A N D L I N G
  //
  //	--------------------------------------------------------------------------

  const dispatch = useAppDispatch();

  //	--------------------------------------------------------------------------
  //
  //	F U N C T I O N S
  //
  //	--------------------------------------------------------------------------

  //	------------------------------------------------------------
  //
  //	Handler for button onClick events.
  //
  //	------------------------------------------------------------

  const onClickButtonHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    //
    const button: HTMLButtonElement = event.currentTarget;

    // minimise/maximise the panel if the user clicks minimise/maximise.
    if (button.name === 'minimisePanel') {
      if (props.redux === true) {
        if (props.index !== undefined) {
          dispatch(props.setMaximised({ filter: false, index: props.index }));
        } else {
          dispatch(props.setMaximised(false));
        }
      } else {
        props.setMaximised(false);
      }
    }
    if (button.name === 'maximisePanel') {
      if (props.redux === true) {
        if (props.index !== undefined) {
          dispatch(props.setMaximised({ filter: true, index: props.index }));
        } else {
          dispatch(props.setMaximised(true));
        }
      } else {
        props.setMaximised(true);
      }
    }
    //
  }; // onClickButtonHandler

  //	------------------------------------------------------------
  //
  //	C O M P O N E N T   C O D E
  //
  //	------------------------------------------------------------

  const minimised: boolean = props.minimised ?? !props.maximised;

  //const padding: string = props.padding === undefined ? '0px' : props.padding;

  return (
    <div
      role="complementary"
      aria-label={props.title}
      style={{
        flex: props.flex === '1 1' ? '1 1' : '0 0 auto',
        height: props.maximised === true ? (props.height ?? 'auto') : 'auto',
        width: props.maximised === true ? (props.width ?? 'auto') : 'auto',
        display: 'flex',
        flexDirection:
          props.position === SidePanelPosition.LEFT ||
          props.position === SidePanelPosition.RIGHT
            ? 'column'
            : 'row',
        margin: props.margin ?? '0px',
        padding: props.padding ?? '0px',
        alignItems: 'flex-end',
      }}
    >
      {/*
       //  the minimised panel
       */}
      {props.hideMinimisedPanel !== true && (
        <button
          className="minimised-panel"
          name="maximisePanel"
          type="button"
          title="Maximise panel"
          onClick={onClickButtonHandler}
          data-maximised={minimised === false ? 'T' : 'F'}
          data-row={props.position === SidePanelPosition.BOTTOM ? 'T' : 'F'}
        >
          <div style={{ flex: '0 0 15px' }} />
          <div
            className="maximise"
            style={{
              transform:
                'rotate(' +
                (props.position === SidePanelPosition.LEFT
                  ? '0'
                  : props.position === SidePanelPosition.RIGHT
                    ? '180'
                    : -90) +
                'deg)',
              paddingTop: '0px',
              paddingBottom:
                (props.position === SidePanelPosition.BOTTOM
                  ? '2'
                  : props.position === SidePanelPosition.RIGHT
                    ? '2'
                    : '0') + 'px',
            }}
          >
            &raquo;
          </div>
          <div className="flex-row text-colour">
            <div
              className={
                props.position === SidePanelPosition.BOTTOM
                  ? 'form-title'
                  : 'rotated-text-box'
              }
            >
              {props.title}
            </div>
          </div>
        </button>
      )}

      {/* the maximised panel */}
      {props.children !== undefined && (
        <div
          className="panel-side"
          data-maximised={props.maximised === true ? 'T' : 'F'}
          style={{
            width: props.width ?? 'auto',
            height: props.height ?? 'auto',
            flex: props.flex !== undefined ? props.flex : '0 0 auto',
            padding: props.padding ?? '0px',
          }}
        >
          {/*
         //  panel title
         */}
          {props.hideTitle !== true && (
            <div
              style={{
                flex: '0 0 auto',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                margin: '10px 10px 0px 10px',
              }}
            >
              <div
                className="header-text"
                style={{ flex: '1 1', margin: '0px 10px 0px 0px' }}
              >
                {props.title}
              </div>
              <div style={{ flex: '0 0 10px' }} />
              <button
                className="minimise"
                name="minimisePanel"
                type="button"
                style={{
                  transform:
                    'rotate(' +
                    (props.position === SidePanelPosition.LEFT
                      ? '0'
                      : props.position === SidePanelPosition.RIGHT
                        ? '180'
                        : -90) +
                    'deg)',
                  paddingTop:
                    (props.position === SidePanelPosition.BOTTOM ? '0' : '0') + 'px',
                  paddingBottom:
                    (props.position === SidePanelPosition.BOTTOM
                      ? '2'
                      : props.position === SidePanelPosition.RIGHT
                        ? '2'
                        : '0') + 'px',
                }}
                title="Minimise panel"
                onClick={onClickButtonHandler}
              >
                &laquo;
              </button>
            </div>
          )}
          {props.hideTitle !== true && <div style={{ flex: '0 0 10px' }} />}

          {/*
         //  The children of this component go here.
         */}
          {props.children}
        </div>
      )}
    </div>
  );

  //
} // SidePanel
